import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Typography } from 'ravenjs';

import InfoBox from 'components/InfoBox';
import { actions as brandingActions } from 'modules/branding';

class App extends Component {
    static propTypes = {
        resetBranding: PropTypes.func.isRequired
    };

    componentDidMount() {
        const { resetBranding } = this.props;
        // Reset the branding back to default.
        resetBranding();
    }

    render() {
        return (
            <InfoBox logo={false}>
                <Typography align="center" fullWidth type="title">
                    Welcome to Mineral&#39;s eSignature App
                </Typography>
                <Typography align="center" gutterBottom="0" fullWidth>
                    Please click the link sent to you in your email to start the eSignature process.
                </Typography>
            </InfoBox>
        );
    }
}

const mapDispatchToProps = {
    resetBranding: brandingActions.resetBranding
};

export default connect(
    null,
    mapDispatchToProps
)(App);
